import { render } from "./MMMemberCompanies.vue?vue&type=template&id=6244f2a0"
import script from "./MMMemberCompanies.vue?vue&type=script&lang=js"
export * from "./MMMemberCompanies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__